import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';

const BUTTON_GAP = 8;

export const SuggestedResponse = styled(Button).attrs({
  btnType: 'tertiary',
  noMargin: true,
})`
  padding: 8px;
  text-align: left;
  justify-content: flex-start;
  flex-shrink: 0;
  width: calc(50% - ${BUTTON_GAP / 2}px);
`;

export const ResponseText = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
})``;

export const ViewAllButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
})`
  padding: 0;
  height: auto;
`;

export const ResponsesHolder = styled(Box).attrs({
  horizontal: true,
})`
  gap: ${BUTTON_GAP}px;
  flex-wrap: wrap;
`;
